import { render, staticRenderFns } from "./PolarRadar.vue?vue&type=template&id=22b2d808"
import script from "./PolarRadar.vue?vue&type=script&lang=js"
export * from "./PolarRadar.vue?vue&type=script&lang=js"
import style0 from "./PolarRadar.vue?vue&type=style&index=0&id=22b2d808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports